<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-scenic-spot`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34.343 41a1 1 0 011 1v2a1 1 0 01-1 1h-21a1 1 0 01-1-1v-2a1 1 0 011-1h21zm7-6a1 1 0 011 1v2a1 1 0 01-1 1h-34a1 1 0 01-1-1v-2a1 1 0 011-1h34zM17.883 8.474a.999.999 0 01.347.35l.13.221-.024.015 1.738 2.894.274.466v-.009l.212.351h-.008l6.74 11.429 4.999-9.45a1 1 0 011.754-.026l.815 1.436-.013.008.952 1.647 7.163 12.626a1 1 0 01-.377 1.363l-1.74.987a1 1 0 01-1.362-.376L33.267 21.45l-4.949 9.355a1 1 0 01-1.745.04l-9.225-15.642L6.945 32.559a1 1 0 01-1.372.344l-1.715-1.028a1 1 0 01-.344-1.372L16.511 8.818a1 1 0 011.372-.344zM32.343 1c6.617 0 12 5.255 12 11.763a11.54 11.54 0 01-1.73 6.088c-.266.43-.56.843-.879 1.235l-2.228-3.861a7.534 7.534 0 00.837-3.462c0-4.277-3.57-7.763-8-7.763-3.945 0-7.257 2.783-7.89 6.476l-2.63-4.378C23.875 3.442 27.843 1 32.343 1zm4.318 18.299l.08.141-.085-.138.005-.003z"/></svg>
</template>
<script>

export default {
  name: 'IconScenicSpot',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
